var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"co pill",class:( _obj = {
        outline: _vm.outline,
        truncate: _vm.truncate
    }, _obj[_vm.variant] = true, _obj ),attrs:{"title":_vm.title || _vm.text}},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }